import React from "react"
import { motion } from 'framer-motion'
import about1 from '../../Assets/Images/about1.png'
import about2 from '../../Assets/Images/about2.png'
import about3 from '../../Assets/Images/about3.png'
import about4 from '../../Assets/Images/about4.png'
import happySmiles from '../../Assets/Images/happySmile.png'
import { useTranslation } from "react-i18next"

const AboutPage = () => {
    const { t } = useTranslation()

    return (
        <motion.div className="w-full min-h-screen flex flex-col">
            {/* Hero Section */}
            <div className="relative w-full h-[60vh] sm:h-[80vh]">
                <img src={about1} alt="About Hero" className="h-full w-full object-cover" />
                <div className="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-start px-6 md:px-20">
                    <div className="bg-white/70 rounded-lg p-5 md:p-10 w-full md:w-2/3 lg:w-1/2">
                        <p className="text-xl md:text-2xl font-bold text-primeColor mb-4">
                            {t('Welcome to Royal Kavery Matrimony Thanjavur Division')}
                        </p>
                        <p className="text-base md:text-lg font-semibold text-black leading-relaxed">
                            {t('At Royal kavery matrimony thanjavur division, we believe that every individual deserves a chance at finding true love and campanionship. Our mission is to create a platform where people from diverse backgrounds can connect and find their life partners in safe, secure, and supportive environment')}
                        </p>
                    </div>
                </div>
            </div>

            {/* Section Title */}
            <div className="w-full flex items-center justify-center my-10 px-4">
                <div className="flex items-center w-full max-w-7xl">
                    <div className="flex-1 h-px bg-primeColor" />
                    <p className="mx-4 text-lg md:text-xl font-bold text-primeColor whitespace-nowrap">{t('Our Story')}</p>
                    <div className="flex-1 h-px bg-primeColor" />
                </div>
            </div>

            {/* Our Story Description */}
            <div className="px-4 md:px-20 mb-10 text-center">
                <p className="text-base md:text-xl font-bold leading-relaxed">
                    {t('Royal Kavery Matrimony Thanjavur Division was founded with the vision of revolutionizing the way people find their life partners. Understanding the challenges and complexities of modern relationships, our founders set out to create a platform that combines the best of traditional matchmaking with advanced technology. Since our inception, we have been committed to helping individuals find meaningful and lasting relationships.')}
                </p>
            </div>

            {/* Section - The Beginning */}
            <div className="flex flex-col md:flex-row items-center gap-8 px-4 md:px-20 my-10">
                <div className="md:w-1/2">
                    <p className="text-2xl md:text-4xl font-bold text-primeColor mb-4">{t('The Beginning')}</p>
                    <p className="text-base md:text-xl font-bold text-black leading-relaxed">
                        {t(`The idea for Royal Kavery Matrimony Thanjavur Division took root when they realized the challenges people face in finding a compatible life partner in today's fast-paced world. With busy schedules, limited social circles, and the growing influence of technology, traditional methods of matchmaking were no longer sufficient. They saw an opportunity to bridge this gap by creating a platform that offers both convenience and reliability.`)}
                    </p>
                </div>
                <div className="md:w-1/2 items-center flex justify-center">
                <img src={about2} alt="Beginning" className="w-full md:w-96 object-contain" />
                </div>
            </div>

            {/* Section - Building the Dream */}
            <div className="flex flex-col md:flex-row-reverse items-center gap-8 px-4 md:px-20 my-10">
                <div className="md:w-1/2">
                    <p className="text-2xl md:text-4xl font-bold text-primeColor mb-4">{t('Building the Dream')}</p>
                    <p className="text-base md:text-xl font-bold text-black leading-relaxed">
                        {t('Building the Dream In 2008, with a shared vision and a deep commitment to helping others, we embarked on their journey to create Royal Kavery Matrimony Thanjavur Division. They assembled a team of experts in technology, relationship counselling, & customer support, all dedicated to providing an exceptional user experience. Together, they developed a platform that combines advanced algorithms with personalized matchmaking services that users find their perfect match.')}
                    </p>
                </div>
                <div className="md:w-1/2 items-center flex justify-center">
                <img src={about3} alt="Building Dream" className="w-full md:w-96 object-contain" />
                </div>
            </div>

            {/* Section - Our Growth */}
            <div className="flex flex-col md:flex-row items-center gap-8 px-4 md:px-20 my-10">
                <div className="md:w-1/2">
                    <p className="text-2xl md:text-4xl font-bold text-primeColor mb-4">{t('Our Growth')}</p>
                    <p className="text-base md:text-xl font-bold text-black leading-relaxed">
                        {t('Since our launch, Royal Kavery Matrimony Thanjavur Division has grown exponentially, becoming a trusted name in the matrimony industry. Our commitment to quality and user satisfaction has earned us the trust of thousands of individuals seeking meaningful relationships. We have expanded our services to cater to diverse communities, offering tailored matchmaking solutions that respect and celebrate cultural and personal preferences.')}
                    </p>
                </div>
                <div className="md:w-1/2 items-center flex justify-center">
                <img src={about4} alt="Our Growth" className="w-full md:w-96 object-contain" />
                </div>
            </div>

            {/* Happy Smiles Banner */}
            <div className="relative h-96 w-full">
                <img src={happySmiles} alt="Happy Smiles" className="object-cover h-full w-full" />
                <div className="absolute inset-0 flex items-center justify-center bg-black/30">
                    <div className="text-center">
                        <p className="text-2xl md:text-4xl text-white font-bold">{t('Happy Smiles')}</p>
                        <p className="text-xl md:text-4xl text-primeColor font-bold mt-2">{"200+"}</p>
                    </div>
                </div>
            </div>
        </motion.div>
    )
}

export default AboutPage